import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { useState } from "react";
import { Subscription } from "../../Types";
import "./index.css";
import Button from "../../Misc/Button";
import { addListener } from "process";
import { useNavigate } from "react-router";

type Props = {
  subscriptions: Subscription[];
};

export default function SubscriptionView({ subscriptions }: Props) {
  const navigate = useNavigate();
  const [toggleSubscription, setToggleSubscription] = useState<number>(0);
  const [isDisappearing, setIsDisappearing] = useState<boolean>(false);

  function toggleSubscriptions(id: number) {
    if (toggleSubscription === id) {
      setIsDisappearing(true);
      setTimeout(() => {
        setToggleSubscription(0);
        setIsDisappearing(false);
      }, 300);
    } else setToggleSubscription(id);
  }

  return (
    <div className="subscription-view">
      <table>
        {subscriptions.map((subscription) => (
          <>
            <tr onClick={() => toggleSubscriptions(subscription.id)} key={subscription.id} className={"subscription-row"}>
              <td style={{ animationDelay: "0s" }}>
                <label>Adress</label>
                <p className="subscription-adress">{subscription.adress.toLowerCase()}</p>
              </td>
              <td style={{ animationDelay: "0.05s" }}>
                <label>Anläggnings-ID</label>
                <p className="subscription-id">{subscription.id}</p>
              </td>
              <td>
                <button
                  className={classNames({
                    "is-active-toggle": subscription.id === toggleSubscription,
                    toggle: true,
                  })}
                  onClick={() => toggleSubscriptions(subscription.id)}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </td>
            </tr>
            {toggleSubscription === subscription.id ? (
              <>
                <tr
                  className={classNames({
                    "subscription-subinfo": true,
                    "is-disappearing": isDisappearing,
                  })}
                >
                  <td style={{ animationDelay: "0.1s" }}>
                    <label>Aktuellt avtal</label>
                    <p>{subscription.agreement}</p>
                  </td>
                  <td style={{ animationDelay: "0.15s" }}>
                    <label>Avtalsperiod</label>
                    <p>{subscription.period}</p>
                  </td>
                  <td style={{ animationDelay: "0.2s" }}>
                    <label>Avtalets start</label>
                    <p>{subscription.startDate.toLocaleDateString("sv-SE", {
                      dateStyle: "medium"
                    })}</p>
                  </td>
                </tr>
                <tr className="subscription-action-container">
                  <Button isActive={false} isPrimary={true} label={"Se statistik"} onClick={() => navigate(`/dashboard/${subscription.id}/monthly/${new Date().getFullYear() + "-" + (new Date().getMonth() + 1)}`)} />
                  <Button isActive={false} isPrimary={true} label={"Visa fakturor"} onClick={() => navigate(`/invoices/${subscription.id}`)} />
                </tr>
              </>
            ) : null}
          </>
        ))}
      </table>
    </div>
  );
}
